export const japaneseFlashcards = {
  categories: [
    {
      jp: "こんにちは",
      rm: "Konnichiwa",
      en: "Hello / Good afternoon",
    },
    {
      jp: "こんばんは",
      rm: "Konbanwa",
      en: "Good evening",
    },
    {
      jp: "おはようございます",
      rm: "Ohayou gozaimasu",
      en: "Good morning",
    },
    {
      jp: "さようなら",
      rm: "Sayounara",
      en: "Goodbye",
    },
    {
      jp: "ありがとう (ございます)",
      rm: "Arigatou (gozaimasu)",
      en: "Thank you (very much)",
    },
    {
      jp: "どうも",
      rm: "Doumo",
      en: "Thanks / Hi / Excuse me",
    },
    {
      jp: "すみません",
      rm: "Sumimasen",
      en: "Excuse me / I'm sorry",
    },
    {
      jp: "ごめんなさい",
      rm: "Gomennasai",
      en: "I'm sorry",
    },
    {
      jp: "どういたしまして",
      rm: "Douitashimashite",
      en: "You're welcome",
    },
    {
      jp: "お願いします",
      rm: "Onegaishimasu",
      en: "Please (request)",
    },
    {
      jp: "はい",
      rm: "Hai",
      en: "Yes",
    },
    {
      jp: "いいえ",
      rm: "Iie",
      en: "No",
    },
    {
      jp: "わかりません",
      rm: "Wakarimasen",
      en: "I don't understand",
    },
    {
      jp: "わかります",
      rm: "Wakarimasu",
      en: "I understand",
    },
    {
      jp: "英語が話せますか？",
      rm: "Eigo ga hanasemasu ka?",
      en: "Do you speak English?",
    },
    {
      jp: "～はどこですか？",
      rm: "~ wa doko desu ka?",
      en: "Where is ~?",
    },
    {
      jp: "トイレはどこですか？",
      rm: "Toire wa doko desu ka?",
      en: "Where is the toilet?",
    },
    {
      jp: "駅はどこですか？",
      rm: "Eki wa doko desu ka?",
      en: "Where is the station?",
    },
    {
      jp: "いくらですか？",
      rm: "Ikura desu ka?",
      en: "How much is it?",
    },
    {
      jp: "これは何ですか？",
      rm: "Kore wa nan desu ka?",
      en: "What is this?",
    },
    {
      jp: "メニューをください",
      rm: "Menyuu o kudasai",
      en: "Menu, please",
    },
    {
      jp: "お水をお願いします",
      rm: "Omizu o onegaishimasu",
      en: "Water, please",
    },
    {
      jp: "お会計をお願いします",
      rm: "Okaikei o onegaishimasu",
      en: "Bill, please",
    },
    {
      jp: "カードは使えますか？",
      rm: "Kaado wa tsukaemasu ka?",
      en: "Can I use a credit card?",
    },
    {
      jp: "助けて！",
      rm: "Tasukete!",
      en: "Help!",
    },
    {
      jp: "大丈夫です",
      rm: "Daijoubu desu",
      en: "I'm okay / It's okay",
    },
    {
      jp: "ちょっと待ってください",
      rm: "Chotto matte kudasai",
      en: "Please wait a moment",
    },
    {
      jp: "ゆっくり話してください",
      rm: "Yukkuri hanashite kudasai",
      en: "Please speak slowly",
    },
    {
      jp: "もう一度お願いします",
      rm: "Mou ichido onegaishimasu",
      en: "Please say it again",
    },
    {
      jp: "写真をとってもらえますか？",
      rm: "Shashin o totte moraemasu ka?",
      en: "Could you take a picture of me?",
    },
    {
      jp: "道に迷いました",
      rm: "Michi ni mayoi mashita",
      en: "I'm lost",
    },
    {
      jp: "～に行きたいです",
      rm: "~ ni ikitai desu",
      en: "I want to go to ~",
    },
    {
      jp: "～までお願いします",
      rm: "~ made onegaishimasu",
      en: "To ~ please (taxi)",
    },
    {
      jp: "予約があります",
      rm: "Yoyaku ga arimasu",
      en: "I have a reservation",
    },
    {
      jp: "予約したいです",
      rm: "Yoyaku shitai desu",
      en: "I want to make a reservation",
    },
    {
      jp: "禁煙席をお願いします",
      rm: "Kin'en seki o onegaishimasu",
      en: "Non-smoking seat, please",
    },
    {
      jp: "喫煙席をお願いします",
      rm: "Kitsuen seki o onegaishimasu",
      en: "Smoking seat, please",
    },
    {
      jp: "おいしい",
      rm: "Oishii",
      en: "Delicious",
    },
    {
      jp: "いただきます",
      rm: "Itadakimasu",
      en: "Let's eat (said before a meal)",
    },
    {
      jp: "ごちそうさまでした",
      rm: "Gochisousama deshita",
      en: "Thank you for the meal (said after eating)",
    },
    {
      jp: "これください",
      rm: "Kore kudasai",
      en: "This one, please",
    },
    {
      jp: "これと同じもの",
      rm: "Kore to onaji mono",
      en: "The same as this",
    },
    {
      jp: "少し高いです",
      rm: "Sukoshi takai desu",
      en: "It's a little expensive",
    },
    {
      jp: "もっと安いのはありますか？",
      rm: "Motto yasui no wa arimasu ka?",
      en: "Do you have anything cheaper?",
    },
    {
      jp: "結構です",
      rm: "Kekkou desu",
      en: "No, thank you",
    },
    {
      jp: "～が好きです",
      rm: "~ ga suki desu",
      en: "I like ~",
    },
    {
      jp: "～が嫌いです",
      rm: "~ ga kirai desu",
      en: "I dislike ~",
    },
    {
      jp: "大丈夫ですか？",
      rm: "Daijoubu desu ka?",
      en: "Are you okay?",
    },
    {
      jp: "疲れています",
      rm: "Tsukarete imasu",
      en: "I'm tired",
    },
    {
      jp: "気分が悪いです",
      rm: "Kibun ga warui desu",
      en: "I feel sick",
    },
    {
      jp: "病院はどこですか？",
      rm: "Byouin wa doko desu ka?",
      en: "Where is the hospital?",
    },
    {
      jp: "薬局はどこですか？",
      rm: "Yakkyoku wa doko desu ka?",
      en: "Where is the pharmacy?",
    },
    {
      jp: "熱があります",
      rm: "Netsu ga arimasu",
      en: "I have a fever",
    },
    {
      jp: "痛いです",
      rm: "Itai desu",
      en: "It hurts",
    },
    {
      jp: "お腹が痛いです",
      rm: "Onaka ga itai desu",
      en: "I have a stomachache",
    },
    {
      jp: "迷子になりました",
      rm: "Maigo ni narimashita",
      en: "I'm lost (child)",
    },
    {
      jp: "警察",
      rm: "Keisatsu",
      en: "Police",
    },
    {
      jp: "消防署",
      rm: "Shoubousho",
      en: "Fire station",
    },
    {
      jp: "緊急です",
      rm: "Kinkyuu desu",
      en: "It's an emergency",
    },
    {
      jp: "～はありますか？",
      rm: "~ wa arimasu ka?",
      en: "Do you have ~?",
    },
    {
      jp: "～を探しています",
      rm: "~ o sagashite imasu",
      en: "I'm looking for ~",
    },
    {
      jp: "両替したいです",
      rm: "Ryougae shitai desu",
      en: "I want to exchange money",
    },
    {
      jp: "パスポートをなくしました",
      rm: "Pasupooto o nakushimashita",
      en: "I lost my passport",
    },
    {
      jp: "～までどのくらいかかりますか？",
      rm: "~ made dono kurai kakarimasu ka?",
      en: "How long does it take to get to ~?",
    },
    {
      jp: "近いですか？",
      rm: "Chikai desu ka?",
      en: "Is it close?",
    },
    {
      jp: "遠いですか？",
      rm: "Tooi desu ka?",
      en: "Is it far?",
    },
    {
      jp: "まっすぐ行ってください",
      rm: "Massugu itte kudasai",
      en: "Please go straight",
    },
    {
      jp: "右に曲がってください",
      rm: "Migi ni magatte kudasai",
      en: "Please turn right",
    },
    {
      jp: "左に曲がってください",
      rm: "Hidari ni magatte kudasai",
      en: "Please turn left",
    },
    {
      jp: "～の近くです",
      rm: "~ no chikaku desu",
      en: "It's near ~",
    },
    {
      jp: "～の向かい側です",
      rm: "~ no mukougawa desu",
      en: "It's across from ~",
    },
    {
      jp: "～の隣です",
      rm: "~ no tonari desu",
      en: "It's next to ~",
    },
    {
      jp: "無料ですか？",
      rm: "Muryou desu ka?",
      en: "Is it free?",
    },
    {
      jp: "割引はありますか？",
      rm: "Waribiki wa arimasu ka?",
      en: "Is there a discount?",
    },
    {
      jp: "～時から～時までです",
      rm: "~ ji kara ~ ji made desu",
      en: "It's from ~ o'clock to ~ o'clock",
    },
    {
      jp: "今日",
      rm: "Kyou",
      en: "Today",
    },
    {
      jp: "明日",
      rm: "Ashita",
      en: "Tomorrow",
    },
    {
      jp: "昨日",
      rm: "Kinou",
      en: "Yesterday",
    },
    {
      jp: "今",
      rm: "Ima",
      en: "Now",
    },
    {
      jp: "後で",
      rm: "Atode",
      en: "Later",
    },
    {
      jp: "いつ",
      rm: "Itsu",
      en: "When",
    },
    {
      jp: "何時ですか？",
      rm: "Nanji desu ka?",
      en: "What time is it?",
    },
    {
      jp: "～をお願いします",
      rm: "~ o onegai shimasu",
      en: "I'll have ~ please",
    },
    {
      jp: "塩",
      rm: "Shio",
      en: "Salt",
    },
    {
      jp: "胡椒",
      rm: "Koshou",
      en: "Pepper",
    },
    {
      jp: "砂糖",
      rm: "Satou",
      en: "Sugar",
    },
    {
      jp: "辛いです",
      rm: "Karai desu",
      en: "It's spicy",
    },
    {
      jp: "甘いです",
      rm: "Amai desu",
      en: "It's sweet",
    },
    {
      jp: "酸っぱいです",
      rm: "Suppai desu",
      en: "It's sour",
    },
    {
      jp: "苦いです",
      rm: "Nigai desu",
      en: "It's bitter",
    },
    {
      jp: "熱い",
      rm: "Atsui",
      en: "Hot",
    },
    {
      jp: "冷たい",
      rm: "Tsumetai",
      en: "Cold",
    },
    {
      jp: "お箸",
      rm: "Ohashi",
      en: "Chopsticks",
    },
    {
      jp: "フォーク",
      rm: "Forku",
      en: "Fork",
    },
    {
      jp: "スプーン",
      rm: "Supuun",
      en: "Spoon",
    },
    {
      jp: "ナイフ",
      rm: "Naifu",
      en: "Knife",
    },
    {
      jp: "お土産",
      rm: "Omiyage",
      en: "Souvenir",
    },
    {
      jp: "税金",
      rm: "Zeikin",
      en: "Tax",
    },
    {
      jp: "～に興味があります",
      rm: "~ ni kyoumi ga arimasu",
      en: "I'm interested in ~",
    },
    {
      jp: "試着できますか？",
      rm: "Shichaku dekimasu ka?",
      en: "Can I try it on?",
    },
    {
      jp: "サイズ",
      rm: "Saizu",
      en: "Size",
    },
    {
      jp: "色が違います",
      rm: "Iro ga chigaimasu",
      en: "The color is different",
    },
    {
      jp: "違うものを見せてください",
      rm: "Chigau mono o misete kudasai",
      en: "Please show me something different",
    },
    {
      jp: "気に入りました",
      rm: "Ki ni irimashita",
      en: "I like it",
    },
    {
      jp: "結構です",
      rm: "Kekkou desu",
      en: "No, thank you",
    },
    {
      jp: "また来ます",
      rm: "Mata kimasu",
      en: "I'll come again",
    },
    {
      jp: "お邪魔します",
      rm: "Ojama shimasu",
      en: "Excuse me for intruding (entering someone's home)",
    },
    {
      jp: "お世話になりました",
      rm: "Osewa ni narimashita",
      en: "Thank you for your help (formal)",
    },
  ]
};
